import type { ManagementAccountFieldName, ManagementAccountFieldPermissions, Roles } from '@common/types/user';

type ManagementAccountFieldPermission = ManagementAccountFieldPermissions[ManagementAccountFieldName];

export const isFieldRequiredByPermission = ({
    permission,
    role,
    jobTitle,
}: {
    permission: ManagementAccountFieldPermission | undefined;
    role?: Roles;
    jobTitle?: string;
}): boolean => {
    if (!permission || permission.read_only) {
        return false;
    }

    const requiredForRole = role !== undefined && permission.required_for_roles?.includes(role);
    const requiredWhen = permission.required_when?.job_title;
    const required = permission.required;

    return Boolean(required || requiredForRole || (requiredWhen !== undefined && requiredWhen === jobTitle));
};
